import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { typesOfFinancialInstitution } from 'commons/types/dictionaries'
import { FF2, Select, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const Type = ({ index }: { index: number }) => {
  const { control, clearErrors, setValue } = useFormContext<SarEdit>()

  const typeOther = useWatch({ control, name: `institutionActivitiesInfo.${index as 0}.typeOther` })

  return (
    <Controller
      name={`institutionActivitiesInfo.${index as 0}.type`}
      control={control}
      rules={{
        validate: Validators.required.field
      }}
      render={({ field }) => (
        <FF2
          required
          field={field}
          label="51. Type of financial institution"
          input={(props) => (
            <Select
              {...props}
              data={typesOfFinancialInstitution}
              data-qa="51. Type of financial institution"
              options-data-qa="51. Type of financial institution option"
              onChange={(value) => {
                if (value === 'Other') {
                  clearErrors(`institutionActivitiesInfo.${index as 0}.typeOther`)
                } else {
                  if (typeOther) {
                    setValue(`institutionActivitiesInfo.${index as 0}.typeOther`, '')
                  }
                }
                field.onChange(value)
              }}
            />
          )}
        />
      )}
    />
  )
}
